import { ProfileStyleModel } from '@/models/header/v2/ProfileModel'

export function formatProfileStyle(data) {
  const h = new ProfileStyleModel()
  h.fromData(data)

  return h
}
